
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M33.73 35H6.23A2.25 2.25 0 0 1 4 32.75V21h3v11h26V21h3v11.75A2.25 2.25 0 0 1 33.73 35zm-7.81-19.06l-4.44 4.44V5h-3v15.38L14 15.94l-2.12 2.12L20 26.12l8-8.06-2.08-2.12z"}})])
          )
        }
      }
    